<template>
  <div class="item">
    <div class="content">
      <div class="ui header">{{ new Date(ins.created).toLocaleString() }}</div>
      <div class="meta">by {{ ins.createdby }}</div>
      <div class="description">
        <span class="ui yellow label vehicle registration" style="color:black!important">{{ ins.reg }}</span><br>{{ ins.inspectionSummary }}</div>
        <div class="meta">
          <a class="ui tiny basic button" :href="'https://shpi.24x7group.co.uk/inspection.print.html?reg='+ins.reg+'&iid='+ins._id">Print</a>
        </div>
        <div class="meta">
          <div class="ui header">Damages:</div>
          <span v-if="!(ins.damages && ins.damages.length)">No damages recorded</span>
          <div class="ui items">
            <div v-for="dam in ins.damages" class="item" :key="dam._id">
              <div class="content">
                <div class="meta" v-if="dam.repaired">
                  <i class="ui check circle icon"></i> Has been repaired
                </div>
                <div class="ui text">{{ dam.title }}</div>
                <div class="description">
                  {{ dam.desc }}<br>
                  Damaged bodyparts:
                  <div style="display:inline-block" v-for="ddl in dam.location" :key="ddl">{{ ddl }}
                    <span v-if="ins.bodypartdots && ins.bodypartdots[ddl] && ins.bodypartdots[ddl].bluedot" class="ui blue empty circular label" title="SMART"></span>
                    <span v-if="ins.bodypartdots && ins.bodypartdots[ddl] && ins.bodypartdots[ddl].pinkdot" class="ui pink empty circular label" title="Dent"></span>
                    <span v-if="ins.bodypartdots && ins.bodypartdots[ddl] && ins.bodypartdots[ddl].yellowdot" class="ui yellow empty circular label" title="Alloys"></span>
                    <span v-if="ins.bodypartdots && ins.bodypartdots[ddl] && ins.bodypartdots[ddl].reddot" class="ui red empty circular label" title="Bodyshop"></span>
                    <span v-if="ins.bodypartdots && ins.bodypartdots[ddl] && ins.bodypartdots[ddl].purpledot" class="ui purple empty circular label" title="Windscreen"></span>
                  </div>
                </div>
              <div class="meta">
                <a v-for="(evid,index) in  dam.evidence" :key="index" :href="this.$host+'/img/'+ins.reg+'/'+evid +'.2.jpg'" target="_black"><img :src="this.$host+'/img/'+ins.reg+'/'+evid+'.jpg'"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['ins']
  }
</script>
